import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

const cities = [
  { name: 'Indianapolis', slug: 'indianapolis', population: '880,000+', county: 'Marion County', description: 'Serving the heart of Indiana with comprehensive life insurance solutions' },
  { name: 'Castleton', slug: 'castleton', population: '30,000+', county: 'Marion County', description: 'Hyper-local life insurance for northeast Indianapolis families in 46250, 46256 & 46240' },
  { name: 'Broad Ripple', slug: 'broad-ripple', population: '15,000+', county: 'Marion County', description: 'Affordable coverage for Broad Ripple\'s young professionals and homeowners' },
  { name: 'Geist', slug: 'geist', population: '20,000+', county: 'Marion / Hamilton County', description: 'Wealth protection and life insurance for Geist Reservoir lakeside families' },
  { name: 'Carmel', slug: 'carmel', population: '100,000+', county: 'Hamilton County', description: 'Protecting Carmel families with personalized insurance coverage' },
  { name: 'Fishers', slug: 'fishers', population: '95,000+', county: 'Hamilton County', description: 'Trusted life insurance partner for Fishers residents' },
  { name: 'Noblesville', slug: 'noblesville', population: '70,000+', county: 'Hamilton County', description: 'Securing Noblesville families\' financial futures' },
  { name: 'Westfield', slug: 'westfield', population: '45,000+', county: 'Hamilton County', description: 'Protecting Westfield families with expert insurance guidance' },
  { name: 'Greenwood', slug: 'greenwood', population: '60,000+', county: 'Johnson County', description: 'Comprehensive insurance solutions for Greenwood communities' },
  { name: 'Avon', slug: 'avon', population: '20,000+', county: 'Hendricks County', description: 'Personalized life insurance for Avon residents' },
  { name: 'Plainfield', slug: 'plainfield', population: '35,000+', county: 'Hendricks County', description: 'Trusted insurance partner for Plainfield families' },
  { name: 'Brownsburg', slug: 'brownsburg', population: '27,000+', county: 'Hendricks County', description: 'Expert insurance guidance for Brownsburg families' },
  { name: 'Lawrence', slug: 'lawrence', population: '50,000+', county: 'Marion County', description: 'Serving Lawrence with tailored insurance solutions' },
  { name: 'Beech Grove', slug: 'beech-grove', population: '15,000+', county: 'Marion County', description: 'Personalized insurance for Beech Grove residents' },
  { name: 'Speedway', slug: 'speedway', population: '12,000+', county: 'Marion County', description: 'Protecting Speedway families with expert care' },
  { name: 'Zionsville', slug: 'zionsville', population: '30,000+', county: 'Boone County', description: 'Comprehensive coverage for Zionsville residents' },
  { name: 'Whitestown', slug: 'whitestown', population: '10,000+', county: 'Boone County', description: 'Trusted life insurance partner in Whitestown' },
  { name: 'Lebanon', slug: 'lebanon', population: '16,000+', county: 'Boone County', description: 'Securing financial futures in Lebanon' },
  { name: 'Mooresville', slug: 'mooresville', population: '10,000+', county: 'Morgan County', description: 'Expert insurance guidance for Mooresville families' },
  { name: 'Anderson', slug: 'anderson', population: '55,000+', county: 'Madison County', description: 'Protecting Anderson families with affordable life insurance solutions' },
  { name: 'Muncie', slug: 'muncie', population: '65,000+', county: 'Delaware County', description: 'Trusted life insurance coverage for Muncie residents and families' },
  { name: 'Columbus', slug: 'columbus', population: '50,000+', county: 'Bartholomew County', description: 'Comprehensive life insurance solutions for Columbus, Indiana families' },
  { name: 'Bloomington', slug: 'bloomington', population: '80,000+', county: 'Monroe County', description: 'Expert life insurance guidance for Bloomington residents and IU families' },
  { name: 'Terre Haute', slug: 'terre-haute', population: '58,000+', county: 'Vigo County', description: 'Personalized life insurance coverage for Terre Haute and Wabash Valley families' },
  { name: 'Kokomo', slug: 'kokomo', population: '58,000+', county: 'Howard County', description: 'Affordable life insurance for Kokomo manufacturing families and Howard County residents' },
  { name: 'Richmond', slug: 'richmond', population: '35,000+', county: 'Wayne County', description: 'Comprehensive life insurance solutions for Richmond and eastern Indiana families' },
  { name: 'Fort Wayne', slug: 'fort-wayne', population: '270,000+', county: 'Allen County', description: 'Expert life insurance guidance for Fort Wayne, Indiana\'s second-largest city' },
  { name: 'Franklin', slug: 'franklin', population: '25,000+', county: 'Johnson County', description: 'Personalized life insurance for Franklin families and Franklin College community members' },
  { name: 'Greenfield', slug: 'greenfield', population: '22,000+', county: 'Hancock County', description: 'Trusted life insurance coverage for Greenfield and Hancock County families' },
  { name: 'Danville', slug: 'danville', population: '10,000+', county: 'Hendricks County', description: 'Expert life insurance guidance for Danville, the Hendricks County seat' },
  { name: 'Martinsville', slug: 'martinsville', population: '12,000+', county: 'Morgan County', description: 'Affordable life insurance solutions for Martinsville and Morgan County residents' },
  { name: 'Cumberland', slug: 'cumberland', population: '6,000+', county: 'Marion / Hancock County', description: 'Local life insurance expertise for Cumberland families on the east side of Indianapolis' },
];

const countyGroups = [
  {
    name: 'Marion County',
    cities: ['Indianapolis', 'Castleton', 'Broad Ripple', 'Lawrence', 'Beech Grove', 'Speedway']
  },
  {
    name: 'Hamilton County',
    cities: ['Carmel', 'Fishers', 'Noblesville', 'Westfield']
  },
  {
    name: 'Marion / Hamilton County',
    cities: ['Geist']
  },
  {
    name: 'Marion / Hancock County',
    cities: ['Cumberland']
  },
  {
    name: 'Hendricks County',
    cities: ['Avon', 'Plainfield', 'Brownsburg', 'Danville']
  },
  {
    name: 'Boone County',
    cities: ['Zionsville', 'Whitestown', 'Lebanon']
  },
  {
    name: 'Johnson County',
    cities: ['Greenwood', 'Franklin']
  },
  {
    name: 'Morgan County',
    cities: ['Mooresville', 'Martinsville']
  },
  {
    name: 'Hancock County',
    cities: ['Greenfield']
  },
  {
    name: 'Madison County',
    cities: ['Anderson']
  },
  {
    name: 'Delaware County',
    cities: ['Muncie']
  },
  {
    name: 'Bartholomew County',
    cities: ['Columbus']
  },
  {
    name: 'Monroe County',
    cities: ['Bloomington']
  },
  {
    name: 'Vigo County',
    cities: ['Terre Haute']
  },
  {
    name: 'Howard County',
    cities: ['Kokomo']
  },
  {
    name: 'Wayne County',
    cities: ['Richmond']
  },
  {
    name: 'Allen County',
    cities: ['Fort Wayne']
  },
];

export default function ServiceAreasPage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://hoosierlifeinsurance.com';

    // Inject meta tags
    const prevTitle = document.title;
    document.title = 'Life Insurance Near Me | 32 Cities Served | Hoosier Life';

    const setMeta = (name: string, content: string, prop = false) => {
      const selector = prop ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let el = document.querySelector(selector) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        prop ? el.setAttribute('property', name) : el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', 'Hoosier Life Insurance serves 32 cities across Central Indiana — Indianapolis, Carmel, Fishers, Noblesville, Greenwood & more. (317) 648-2983.');
    setMeta('keywords', 'Indiana life insurance service areas, Indianapolis life insurance, Bloomington life insurance, Terre Haute insurance agent, Anderson life insurance, Muncie life insurance, local insurance coverage Indiana');
    setMeta('geo.region', 'US-IN');
    setMeta('geo.placename', 'Indiana');

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${siteUrl}/service-areas`);
    setMeta('last-modified', new Date().toISOString());

    const schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebPage',
          '@id': `${siteUrl}/service-areas#webpage`,
          'url': `${siteUrl}/service-areas`,
          'name': 'Indiana Life Insurance Service Areas - 32 Cities Served | Hoosier Life Insurance',
          'description': 'Find local life insurance experts across Indiana. Hoosier Life Insurance serves Indianapolis, Carmel, Fishers, Noblesville, Greenwood & more. Complete list of cities served by Hoosier Life Insurance across Indiana',
          'inLanguage': 'en-US',
          'datePublished': '2024-01-15T00:00:00-05:00',
          'dateModified': new Date().toISOString(),
          'isPartOf': { '@id': `${siteUrl}/#website` },
          'breadcrumb': { '@id': `${siteUrl}/service-areas#breadcrumb` },
        },
        {
          '@type': 'BreadcrumbList',
          '@id': `${siteUrl}/service-areas#breadcrumb`,
          'itemListElement': [
            { '@type': 'ListItem', 'position': 1, 'name': 'Home', 'item': `${siteUrl}/` },
            { '@type': 'ListItem', 'position': 2, 'name': 'Service Areas', 'item': `${siteUrl}/service-areas` },
          ],
        },
        {
          '@type': 'ItemList',
          '@id': `${siteUrl}/service-areas#itemlist`,
          'name': 'Indiana Life Insurance Service Areas',
          'description': 'Complete list of cities served by Hoosier Life Insurance across Indiana',
          'numberOfItems': cities.length,
          'itemListElement': cities.map((city, index) => ({
            '@type': 'ListItem',
            'position': index + 1,
            'name': `Life Insurance in ${city.name}`,
            'url': `${siteUrl}/service-areas/${city.slug}`,
            'description': city.description,
          })),
        },
      ],
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-service-areas-hub';
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      document.title = prevTitle;
      const existingScript = document.getElementById('schema-service-areas-hub');
      if (existingScript) document.head.removeChild(existingScript);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <title>Life Insurance Near Me | 32 Indiana Cities Served | Hoosier Life Insurance</title>
      <Header />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white py-24 pt-40">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/20"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-5xl font-bold mb-6">
              Life Insurance Across Indiana — 32 Cities &amp; Neighborhoods Served
            </h1>
            <p className="text-xl text-gray-200 leading-relaxed">
              Local expertise, personalized service, and comprehensive life insurance solutions throughout Central Indiana. Find your dedicated insurance partner in your community.
            </p>
          </div>
        </div>
      </section>

      {/* Quick Links to All Cities - Internal Links Section */}
      <section className="py-16 bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="inline-block text-xs font-bold tracking-widest text-orange-600 uppercase mb-3">
              Jump to Your City
            </span>
            <h2 className="text-3xl font-bold text-slate-900 mb-4">
              Find <strong>Life Insurance</strong> in Your Community
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Select your city below to view local coverage options, neighborhood insights, and connect with your dedicated insurance expert.
            </p>
          </div>

          {/* Featured Cities Banner - Priority Internal Links */}
          <div className="mb-12 grid md:grid-cols-2 gap-6">
            {/* Indianapolis Featured Card */}
            <Link
              to="/life-insurance-indianapolis"
              className="group relative bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16"></div>
              <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full -ml-12 -mb-12"></div>
              <div className="relative z-10">
                <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm border border-white/30 rounded-full px-3 py-1 mb-4">
                  <i className="ri-star-fill text-white text-xs"></i>
                  <span className="text-white text-xs font-bold uppercase tracking-wide">Featured City</span>
                </div>
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-16 h-16 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-building-2-fill text-4xl text-white"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-white mb-2">
                      Life Insurance in <strong>Indianapolis</strong>
                    </h3>
                    <p className="text-white/90 text-sm leading-relaxed">
                      Comprehensive coverage for Indianapolis residents, Marion County families, Eli Lilly employees, and IUPUI staff. Serving all 15 neighborhoods.
                    </p>
                  </div>
                </div>
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="text-xs bg-white/20 backdrop-blur-sm border border-white/30 text-white font-semibold px-3 py-1 rounded-full">
                    880,000+ Residents
                  </span>
                  <span className="text-xs bg-white/20 backdrop-blur-sm border border-white/30 text-white font-semibold px-3 py-1 rounded-full">
                    15 Neighborhoods
                  </span>
                  <span className="text-xs bg-white/20 backdrop-blur-sm border border-white/30 text-white font-semibold px-3 py-1 rounded-full">
                    Marion County
                  </span>
                </div>
                <div className="flex items-center gap-2 text-white font-bold group-hover:gap-4 transition-all">
                  View Indianapolis Coverage <i className="ri-arrow-right-line text-xl"></i>
                </div>
              </div>
            </Link>

            {/* Fort Wayne Featured Card */}
            <Link
              to="/life-insurance-fort-wayne"
              className="group relative bg-gradient-to-br from-slate-700 to-slate-800 rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full -mr-16 -mt-16"></div>
              <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/5 rounded-full -ml-12 -mb-12"></div>
              <div className="relative z-10">
                <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-3 py-1 mb-4">
                  <i className="ri-star-fill text-orange-400 text-xs"></i>
                  <span className="text-white text-xs font-bold uppercase tracking-wide">Featured City</span>
                </div>
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-16 h-16 rounded-xl bg-white/10 backdrop-blur-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-building-4-fill text-4xl text-orange-400"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-white mb-2">
                      Life Insurance in <strong>Fort Wayne</strong>
                    </h3>
                    <p className="text-white/80 text-sm leading-relaxed">
                      Expert coverage for Fort Wayne, Allen County, Lincoln Financial employees, and Parkview Health workers. Serving 15+ neighborhoods.
                    </p>
                  </div>
                </div>
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="text-xs bg-white/10 backdrop-blur-sm border border-white/20 text-white font-semibold px-3 py-1 rounded-full">
                    270,000+ Residents
                  </span>
                  <span className="text-xs bg-white/10 backdrop-blur-sm border border-white/20 text-white font-semibold px-3 py-1 rounded-full">
                    15+ Neighborhoods
                  </span>
                  <span className="text-xs bg-white/10 backdrop-blur-sm border border-white/20 text-white font-semibold px-3 py-1 rounded-full">
                    Allen County
                  </span>
                </div>
                <div className="flex items-center gap-2 text-white font-bold group-hover:gap-4 transition-all">
                  View Fort Wayne Coverage <i className="ri-arrow-right-line text-xl"></i>
                </div>
              </div>
            </Link>

            {/* Marion County Banner */}
            <div className="mb-10 bg-[#F9F7F4] border border-orange-200 rounded-xl p-5 flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-orange-100 rounded-lg flex-shrink-0">
                  <i className="ri-map-pin-2-fill text-orange-600 text-lg"></i>
                </div>
                <div>
                  <p className="font-bold text-slate-900 text-sm">Marion County, Indiana</p>
                  <p className="text-xs text-gray-600">Indianapolis metro — 6 communities served, 880,000+ residents</p>
                </div>
              </div>
              <Link
                to="/service-areas/marion-county"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-orange-600 text-white text-sm font-bold rounded-lg hover:bg-orange-700 transition-colors whitespace-nowrap"
              >
                View Marion County Coverage
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          <div className="space-y-10">
            {countyGroups.map((county) => (
              <div key={county.name}>
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-bold text-slate-900 flex items-center">
                    <i className="ri-map-pin-2-fill text-orange-600 mr-2 text-xl"></i>
                    {county.name}
                  </h3>
                  {county.name === 'Marion County' && (
                    <Link
                      to="/service-areas/marion-county"
                      className="text-xs font-semibold text-orange-600 hover:text-orange-700 flex items-center gap-1 transition-colors"
                    >
                      All Marion County Cities <i className="ri-arrow-right-s-line"></i>
                    </Link>
                  )}
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
                  {county.cities.map((cityName) => {
                    const city = cities.find(c => c.name === cityName);
                    return city ? (
                      <Link
                        key={city.slug}
                        to={`/service-areas/${city.slug}`}
                        className="group flex items-center justify-between px-4 py-3 bg-gray-50 rounded-lg hover:bg-orange-50 hover:shadow-md transition-all duration-200 border border-gray-200 hover:border-orange-500"
                      >
                        <span className="font-bold text-sm text-slate-900 group-hover:text-orange-600 transition-colors">
                          Life Insurance in {city.name}
                        </span>
                        <i className="ri-arrow-right-line text-orange-600 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                      </Link>
                    ) : null;
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── LOCAL BUSINESS SPOTLIGHT ── */}
      <section className="py-16 bg-[#FDF9F6] border-b border-orange-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <span className="inline-block text-[12px] font-semibold tracking-widest text-orange-600 uppercase mb-2">
              How We Serve You
            </span>
            <h2 className="text-3xl font-bold text-slate-900 mb-3">
              <strong>Phone · Video · In-Home</strong> Consultations
            </h2>
            <p className="text-gray-600 max-w-xl mx-auto text-[15px]">
              We come to you — no office visit needed. 95% of our consultations are done by phone, video conference, or face-to-face presentation.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-10 items-start">
            {/* Info Cards */}
            <div className="flex flex-col gap-5">
              <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 flex items-start gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-orange-100 shrink-0">
                  <i className="ri-phone-fill text-[22px] text-orange-600"></i>
                </div>
                <div>
                  <p className="text-[12px] font-semibold text-slate-700 uppercase tracking-wide mb-1">Phone Consultation</p>
                  <a href="tel:+13176482983" className="text-[15px] font-semibold text-slate-900 hover:text-orange-600 transition-colors cursor-pointer">
                    (317) 648-2983
                  </a>
                  <p className="text-[12px] text-gray-500 mt-0.5">Missed call? We&apos;ll text you right back.</p>
                </div>
              </div>

              <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 flex items-start gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-orange-100 shrink-0">
                  <i className="ri-vidicon-fill text-[22px] text-orange-600"></i>
                </div>
                <div>
                  <p className="text-[12px] font-semibold text-slate-700 uppercase tracking-wide mb-1">Video Conference</p>
                  <p className="text-[15px] font-semibold text-slate-900 leading-snug">
                    Zoom, Google Meet, or FaceTime
                  </p>
                  <p className="text-[12px] text-gray-500 mt-0.5">Meet face-to-face from anywhere</p>
                </div>
              </div>

              <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 flex items-start gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-orange-100 shrink-0">
                  <i className="ri-home-heart-fill text-[22px] text-orange-600"></i>
                </div>
                <div>
                  <p className="text-[12px] font-semibold text-slate-700 uppercase tracking-wide mb-1">In-Home Presentation</p>
                  <p className="text-[15px] font-semibold text-slate-900 leading-snug">
                    We come to your home or office
                  </p>
                  <p className="text-[12px] text-gray-500 mt-0.5">Convenient, personalized service</p>
                </div>
              </div>

              <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 flex items-start gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-orange-100 shrink-0">
                  <i className="ri-mail-fill text-[22px] text-orange-600"></i>
                </div>
                <div>
                  <p className="text-[12px] font-semibold text-slate-700 uppercase tracking-wide mb-1">Email</p>
                  <a href="mailto:info@hoosierlifeinsurance.com" className="text-[15px] font-semibold text-slate-900 hover:text-orange-600 transition-colors cursor-pointer">
                    info@hoosierlifeinsurance.com
                  </a>
                  <p className="text-[12px] text-gray-500 mt-0.5">We reply within 24 hours</p>
                </div>
              </div>

              <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 flex items-start gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-orange-100 shrink-0">
                  <i className="ri-time-fill text-[22px] text-orange-600"></i>
                </div>
                <div>
                  <p className="text-[12px] font-semibold text-slate-700 uppercase tracking-wide mb-2">Business Hours (EST)</p>
                  <div className="space-y-1">
                    <div className="flex justify-between gap-8 text-[14px]">
                      <span className="text-slate-700 font-medium">Monday – Friday</span>
                      <span className="text-slate-900 font-semibold">9:00 AM – 5:00 PM</span>
                    </div>
                    <div className="flex justify-between gap-8 text-[14px]">
                      <span className="text-slate-700 font-medium">Saturday</span>
                      <span className="text-slate-900 font-semibold">8:00 AM – 1:00 PM</span>
                    </div>
                    <div className="flex justify-between gap-8 text-[14px]">
                      <span className="text-slate-700 font-medium">Sunday</span>
                      <span className="text-gray-400 font-medium">Closed</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-orange-600 text-white rounded-xl p-5 shadow-md">
                <p className="text-[13px] font-semibold uppercase tracking-wide mb-2 text-orange-100">Service Area Business</p>
                <p className="text-[15px] font-bold mb-3">Serving Central Indiana</p>
                <div className="flex flex-wrap gap-2">
                  {['Castleton', 'Lawrence', 'Geist', 'Nora', 'Broad Ripple', 'Fishers', 'Carmel', 'Noblesville', 'Greenwood', 'Avon', 'Anderson', 'Muncie', 'Columbus', 'Bloomington', 'Terre Haute', 'Kokomo', 'Richmond', 'Fort Wayne'].map((n) => (
                    <span key={n} className="bg-white/15 text-white text-[12px] font-medium px-3 py-1 rounded-full border border-white/20">
                      {n}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Map */}
            <div className="rounded-2xl overflow-hidden shadow-xl border border-gray-100 h-[480px]">
              <iframe
                title="Hoosier Life Insurance Service Area — Central Indiana"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d196281.1!2d-86.2520607!3d39.7683965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x886b50ffa7796a03%3A0xd68e9df640b9ea7c!2sIndianapolis%2C%20IN!5e0!3m2!1sen!2sus!4v1700000000000"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
              <p className="text-xs text-gray-500 text-center mt-2 px-4">
                We come to you — serving all of Central Indiana
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── SERVICE AREA ZIP CODES — Local SEO Section ── */}
      <section className="py-16 bg-[#0a1628]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 bg-orange-500/20 border border-orange-400/30 rounded-full px-4 py-1.5 mb-4">
              <i className="ri-map-2-line text-orange-400 text-sm"></i>
              <span className="text-orange-300 text-sm font-medium">Local Coverage</span>
            </div>
            <h2 className="text-3xl font-bold text-white mb-3">
              Areas We Serve &amp; ZIP Codes
            </h2>
            <p className="text-blue-200/70 max-w-2xl mx-auto text-sm">
              Hoosier Life Insurance proudly serves Indianapolis and the surrounding Central Indiana communities. If you live in any of these ZIP codes, we can help protect your family.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Indianapolis */}
            <div className="bg-white/5 border border-white/10 rounded-xl p-5 hover:bg-white/10 transition-colors">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-orange-500/20 rounded-lg">
                  <i className="ri-building-2-line text-orange-400"></i>
                </div>
                <h3 className="text-white font-bold text-base">Indianapolis</h3>
              </div>
              <div className="flex flex-wrap gap-2">
                {['46201','46202','46203','46204','46205','46208','46218','46220','46240','46250','46256','46260','46268'].map(zip => (
                  <span key={zip} className="text-xs bg-white/10 text-blue-200 px-2 py-1 rounded font-mono">{zip}</span>
                ))}
              </div>
            </div>

            {/* Carmel & Fishers */}
            <div className="bg-white/5 border border-white/10 rounded-xl p-5 hover:bg-white/10 transition-colors">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-orange-500/20 rounded-lg">
                  <i className="ri-home-4-line text-orange-400"></i>
                </div>
                <h3 className="text-white font-bold text-base">Carmel &amp; Fishers</h3>
              </div>
              <div className="flex flex-wrap gap-2">
                {['46032','46033','46037','46038','46040','46055','46280','46290'].map(zip => (
                  <span key={zip} className="text-xs bg-white/10 text-blue-200 px-2 py-1 rounded font-mono">{zip}</span>
                ))}
              </div>
            </div>

            {/* Noblesville & Hamilton County */}
            <div className="bg-white/5 border border-white/10 rounded-xl p-5 hover:bg-white/10 transition-colors">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-orange-500/20 rounded-lg">
                  <i className="ri-map-pin-2-line text-orange-400"></i>
                </div>
                <h3 className="text-white font-bold text-base">Noblesville &amp; Hamilton Co.</h3>
              </div>
              <div className="flex flex-wrap gap-2">
                {['46060','46061','46062','46064','46069','46074','46077'].map(zip => (
                  <span key={zip} className="text-xs bg-white/10 text-blue-200 px-2 py-1 rounded font-mono">{zip}</span>
                ))}
              </div>
            </div>

            {/* Greenwood & Johnson County */}
            <div className="bg-white/5 border border-white/10 rounded-xl p-5 hover:bg-white/10 transition-colors">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-orange-500/20 rounded-lg">
                  <i className="ri-community-line text-orange-400"></i>
                </div>
                <h3 className="text-white font-bold text-base">Greenwood &amp; Johnson Co.</h3>
              </div>
              <div className="flex flex-wrap gap-2">
                {['46142','46143','46184','46227','46237','46259'].map(zip => (
                  <span key={zip} className="text-xs bg-white/10 text-blue-200 px-2 py-1 rounded font-mono">{zip}</span>
                ))}
              </div>
            </div>

            {/* Avon, Plainfield & Hendricks County */}
            <div className="bg-white/5 border border-white/10 rounded-xl p-5 hover:bg-white/10 transition-colors">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-orange-500/20 rounded-lg">
                  <i className="ri-road-map-line text-orange-400"></i>
                </div>
                <h3 className="text-white font-bold text-base">Avon &amp; Hendricks Co.</h3>
              </div>
              <div className="flex flex-wrap gap-2">
                {['46123','46168','46231','46234','46278'].map(zip => (
                  <span key={zip} className="text-xs bg-white/10 text-blue-200 px-2 py-1 rounded font-mono">{zip}</span>
                ))}
              </div>
            </div>

            {/* Lawrence, Beech Grove & Surrounding */}
            <div className="bg-white/5 border border-white/10 rounded-xl p-5 hover:bg-white/10 transition-colors">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-orange-500/20 rounded-lg">
                  <i className="ri-pin-distance-line text-orange-400"></i>
                </div>
                <h3 className="text-white font-bold text-base">Lawrence &amp; Beech Grove</h3>
              </div>
              <div className="flex flex-wrap gap-2">
                {['46107','46163','46216','46219','46229','46235','46236','46239'].map(zip => (
                  <span key={zip} className="text-xs bg-white/10 text-blue-200 px-2 py-1 rounded font-mono">{zip}</span>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-8 text-center">
            <p className="text-blue-200/60 text-sm mb-4">
              Don't see your ZIP code? We likely still serve your area — give us a call!
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href="tel:+13176482983"
                className="inline-flex items-center gap-2 px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-fill"></i>
                Call (317) 648-2983
              </a>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-semibold rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-mail-line"></i>
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* County-Based City Links Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">
              Find <strong>Life Insurance</strong> in Your City
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Click on your city to learn more about our local services, coverage options, and how we protect families in your community.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12">
            {countyGroups.map((county) => (
              <div key={county.name} className="bg-gray-50 rounded-2xl p-8 border border-gray-200">
                <h3 className="text-2xl font-bold text-slate-900 mb-6 flex items-center">
                  <i className="ri-map-pin-2-fill text-orange-600 mr-3"></i>
                  {county.name}
                </h3>
                <ul className="space-y-3">
                  {county.cities.map((cityName) => {
                    const city = cities.find(c => c.name === cityName);
                    return city ? (
                      <li key={city.slug}>
                        <Link
                          to={`/service-areas/${city.slug}`}
                          className="group flex items-center justify-between p-4 bg-white rounded-lg hover:shadow-md transition-all duration-200 border border-gray-100 hover:border-orange-500"
                        >
                          <span className="font-bold text-slate-900 group-hover:text-orange-600 transition-colors">
                            Life Insurance in {city.name}
                          </span>
                          <i className="ri-arrow-right-line text-orange-600 text-xl opacity-0 group-hover:opacity-100 transition-opacity"></i>
                        </Link>
                      </li>
                    ) : null;
                  })}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* All Cities Anchor Text Link List */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">
              <strong>Complete Service Area Directory</strong>
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Browse all 32 cities where Hoosier Life Insurance provides expert life insurance guidance and personalized coverage solutions.
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 lg:p-12 border border-gray-200">
            <ul className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
              {cities.map((city) => (
                <li key={city.slug}>
                  <Link
                    to={`/service-areas/${city.slug}`}
                    className="flex items-center gap-3 p-3 rounded-lg hover:bg-orange-50 transition-colors group"
                  >
                    <i className="ri-map-pin-line text-orange-600 text-lg flex-shrink-0"></i>
                    <span className="font-bold text-slate-900 group-hover:text-orange-600 transition-colors text-sm">
                      Life Insurance in {city.name}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* ── OUR INSURANCE PRODUCTS SECTION ── */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-orange-100 border border-orange-200 rounded-full px-4 py-1.5 mb-4">
              <i className="ri-shield-check-line text-orange-600 text-sm"></i>
              <span className="text-orange-700 text-sm font-semibold">Coverage Options</span>
            </div>
            <h2 className="text-4xl font-bold text-slate-900 mb-4">
              Life Insurance Products We Offer <strong>Across Indiana</strong>
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
              No matter which city you call home, all of our comprehensive life insurance products are available to protect your family. From term life to annuities, we have the right coverage for every stage of life.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
            {/* Term Life Insurance */}
            <Link
              to="/term-life"
              className="group bg-gradient-to-br from-orange-50 to-white rounded-xl p-6 shadow-sm hover:shadow-xl transition-all duration-300 border border-orange-100 hover:border-orange-500"
            >
              <div className="w-14 h-14 rounded-xl bg-orange-100 flex items-center justify-center mb-4 group-hover:bg-orange-600 transition-colors">
                <i className="ri-calendar-check-line text-3xl text-orange-600 group-hover:text-white transition-colors"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-orange-600 transition-colors">
                Term Life
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                Affordable coverage for a specific period — perfect for young families and mortgage protection.
              </p>
              <span className="inline-flex items-center text-sm font-bold text-orange-600 group-hover:underline">
                Learn More <i className="ri-arrow-right-line ml-1"></i>
              </span>
            </Link>

            {/* Whole Life Insurance */}
            <Link
              to="/whole-life"
              className="group bg-gradient-to-br from-orange-50 to-white rounded-xl p-6 shadow-sm hover:shadow-xl transition-all duration-300 border border-orange-100 hover:border-orange-500"
            >
              <div className="w-14 h-14 rounded-xl bg-orange-100 flex items-center justify-center mb-4 group-hover:bg-orange-600 transition-colors">
                <i className="ri-infinity-line text-3xl text-orange-600 group-hover:text-white transition-colors"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-orange-600 transition-colors">
                Whole Life
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                Lifetime protection with cash value growth — build wealth while securing your family's future.
              </p>
              <span className="inline-flex items-center text-sm font-bold text-orange-600 group-hover:underline">
                Learn More <i className="ri-arrow-right-line ml-1"></i>
              </span>
            </Link>

            {/* Final Expense Insurance */}
            <Link
              to="/final-expense"
              className="group bg-gradient-to-br from-orange-50 to-white rounded-xl p-6 shadow-sm hover:shadow-xl transition-all duration-300 border border-orange-100 hover:border-orange-500"
            >
              <div className="w-14 h-14 rounded-xl bg-orange-100 flex items-center justify-center mb-4 group-hover:bg-orange-600 transition-colors">
                <i className="ri-hand-heart-line text-3xl text-orange-600 group-hover:text-white transition-colors"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-orange-600 transition-colors">
                Final Expense
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                Cover funeral and burial costs so your loved ones don't face financial burden during difficult times.
              </p>
              <span className="inline-flex items-center text-sm font-bold text-orange-600 group-hover:underline">
                Learn More <i className="ri-arrow-right-line ml-1"></i>
              </span>
            </Link>

            {/* Mortgage Protection */}
            <Link
              to="/mortgage-protection"
              className="group bg-gradient-to-br from-orange-50 to-white rounded-xl p-6 shadow-sm hover:shadow-xl transition-all duration-300 border border-orange-100 hover:border-orange-500"
            >
              <div className="w-14 h-14 rounded-xl bg-orange-100 flex items-center justify-center mb-4 group-hover:bg-orange-600 transition-colors">
                <i className="ri-home-heart-line text-3xl text-orange-600 group-hover:text-white transition-colors"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-orange-600 transition-colors">
                Mortgage Protection
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                Ensure your family keeps the home if something happens to you — no mortgage worries.
              </p>
              <span className="inline-flex items-center text-sm font-bold text-orange-600 group-hover:underline">
                Learn More <i className="ri-arrow-right-line ml-1"></i>
              </span>
            </Link>

            {/* Annuities */}
            <Link
              to="/annuities"
              className="group bg-gradient-to-br from-orange-50 to-white rounded-xl p-6 shadow-sm hover:shadow-xl transition-all duration-300 border border-orange-100 hover:border-orange-500"
            >
              <div className="w-14 h-14 rounded-xl bg-orange-100 flex items-center justify-center mb-4 group-hover:bg-orange-600 transition-colors">
                <i className="ri-line-chart-line text-3xl text-orange-600 group-hover:text-white transition-colors"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-orange-600 transition-colors">
                Annuities
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                Guaranteed retirement income and tax-deferred growth — secure your golden years with confidence.
              </p>
              <span className="inline-flex items-center text-sm font-bold text-orange-600 group-hover:underline">
                Learn More <i className="ri-arrow-right-line ml-1"></i>
              </span>
            </Link>
          </div>

          <div className="mt-12 text-center">
            <div className="inline-flex flex-col sm:flex-row items-center gap-4 bg-gray-50 rounded-xl p-6 border border-gray-200">
              <div className="flex items-center gap-3">
                <i className="ri-checkbox-circle-fill text-orange-600 text-2xl"></i>
                <p className="text-sm text-gray-700 font-medium">
                  All products available in every city we serve
                </p>
              </div>
              <Link
                to="/all-services"
                className="inline-flex items-center gap-2 px-6 py-3 bg-orange-600 hover:bg-orange-700 text-white font-semibold rounded-lg transition-colors whitespace-nowrap"
              >
                View All Services <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Cities Grid with Cards */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">
              Explore <strong>Local Insurance Services</strong>
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Discover how we serve families in each community with tailored life insurance solutions.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {cities.map((city) => (
              <Link
                key={city.slug}
                to={`/service-areas/${city.slug}`}
                className="group bg-white rounded-lg p-6 shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-orange-500"
              >
                <div className="flex items-start justify-between mb-3">
                  <h3 className="text-xl font-bold text-slate-900 group-hover:text-orange-600 transition-colors">
                    {city.name}
                  </h3>
                  <i className="ri-arrow-right-line text-orange-600 text-xl opacity-0 group-hover:opacity-100 transition-opacity"></i>
                </div>
                <p className="text-sm text-gray-500 mb-2 font-medium">{city.population} residents</p>
                <p className="text-xs text-orange-600 mb-3 font-bold">{city.county}</p>
                <p className="text-sm text-gray-600 leading-relaxed">{city.description}</p>
                <div className="mt-4 pt-4 border-t border-gray-100">
                  <span className="text-sm font-bold text-orange-600 group-hover:underline">
                    Life Insurance in {city.name} →
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Coverage Map Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">
              <strong>Our Coverage Region</strong> Across Indiana
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              We serve families throughout Central Indiana and beyond. Find a local agent near you.
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-12 items-start">
            <div className="lg:col-span-2">
              <div className="rounded-2xl overflow-hidden shadow-2xl border border-gray-100" style={{ height: '480px' }}>
                <iframe
                  title="Hoosier Life Insurance Service Area Map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d778423.8!2d-86.5264!3d39.7684!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x886b50ffa7796a03%3A0xd68e9df640b9ea7c!2sIndianapolis%2C%20IN!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
              <p className="text-xs text-gray-400 mt-2 text-center">
                Coverage spans Indianapolis metro and surrounding Central Indiana communities
              </p>
            </div>

            <div className="space-y-6">
              <div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">
                  Local Expertise, <strong>Statewide Reach</strong>
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-6">
                  Whether you&apos;re in a bustling metro area or a quiet rural community, Hoosier Life Insurance is here to protect your family&apos;s financial future.
                </p>
              </div>

              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-orange-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-orange-600 text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 mb-1 text-sm">Local Agents Who Know Your Area</h4>
                    <p className="text-gray-600 text-xs">Our agents live and work in your community, understanding local needs and challenges.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-orange-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-orange-600 text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 mb-1 text-sm">Comprehensive Coverage Options</h4>
                    <p className="text-gray-600 text-xs">From term life to whole life, final expense to annuities — solutions for every stage of life.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-orange-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-customer-service-2-line text-orange-600 text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 mb-1 text-sm">Personalized Service &amp; Support</h4>
                    <p className="text-gray-600 text-xs">We take the time to understand your unique situation and recommend the right coverage.</p>
                  </div>
                </div>
              </div>

              <div className="bg-orange-600 text-white rounded-xl p-6 shadow-lg">
                <p className="text-4xl font-bold mb-1">32+</p>
                <p className="text-sm font-medium mb-3">Cities &amp; Neighborhoods Served Across Indiana</p>
                <Link
                  to="/wealth-strategy-call"
                  className="inline-flex items-center text-sm font-bold bg-white text-orange-600 px-4 py-2 rounded-lg hover:bg-orange-50 transition-colors whitespace-nowrap"
                >
                  <i className="ri-calendar-line mr-2"></i>
                  Book Free Consultation
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-slate-900 to-slate-800 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">
            Ready to Protect Your Family&apos;s Future?
          </h2>
          <p className="text-xl text-gray-200 mb-8 leading-relaxed">
            Connect with a local insurance expert in your area today. Get a free quote and personalized recommendations in minutes.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/wealth-strategy-call"
              className="inline-flex items-center justify-center px-8 py-4 bg-orange-600 text-white font-bold rounded-lg hover:bg-orange-700 transition-colors whitespace-nowrap"
            >
              <i className="ri-calendar-line mr-2"></i>
              Schedule Free Consultation
            </Link>
            <a
              href="/#contact"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-slate-900 font-bold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-message-3-line mr-2"></i>
              Get Free Quote
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}